import { render } from "./Resource.vue?vue&type=template&id=de7fd4a8&scoped=true"
import script from "./Resource.vue?vue&type=script&lang=js"
export * from "./Resource.vue?vue&type=script&lang=js"

import "./Resource.vue?vue&type=style&index=0&id=de7fd4a8&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\bm365\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de7fd4a8"]])

export default __exports__